import { ProductFamily } from '@chegg/commerce-utils';
export var CSResubscribe = {
  paymentMethodsHeadingText: 'Payment on file',
  subscriptionInfo: {
    header: 'Resubscribe to Chegg Study',
    subHeader: 'Almost there! We just need to confirm your payment.',
    billingCadence: {
      monthly: '/mo.',
      semiAnnual: '/mo.',
      annual: '/yr.'
    }
  },
  devicePolicy: {
    heading: 'Device policy:',
    policyText: 'You can access and use Chegg Study on up to two (2) different devices that must be registered at My Account > My Devices.'
  },
  cta: {
    cta: 'Resubscribe',
    reviewButtonText: 'Review',
    upgradeButtonText: 'Upgrade',
    secondaryCta: 'Cancel'
  },
  saleBanner: {
    bannerTitle: "Congrats, you're saving up to 50% off with our Early Semester Sale! -  Limited Time only!",
    link: '/promo/early-semester-sale',
    linkText: 'See sale terms and conditions'
  },
  notificationBanner: {
    bannerTitle: "VPN detected - Please turn off any VPN connections, and refresh the page to see accurate pricing for your region.",
    link: '#',
    linkText: 'Refresh the page'
  },
  tax: {
    taxInfo: 'Your payment method will be charged __${price}/mo.__ + applicable tax',
    discountedTaxInfo: 'Your payment method will be charged ~~${basePrice}~~ __${price}__ + applicable tax'
  },
  valueProps: {
    line1: 'Your Chegg Study subscription includes:',
    line2: '',
    itemListCollection: {
      items: [{
        line1: 'Ask questions of experts and enthusiasts 24/7'
      }, {
        line1: 'Search millions of homework answers'
      }]
    },
    productFamily: ProductFamily.CHEGG_STUDY
  },
  coupon: {
    buttonText: 'Got coupon?',
    labelText: 'Coupon Code',
    placeholderText: 'Enter coupon code',
    addCouponText: 'Apply',
    removeCouponText: 'Remove',
    termsCtaText: 'Terms apply',
    successText: 'Coupon applied!',
    termsLabelText: 'Coupon terms'
  },
  termsAndConditions: {
    billingHeading: 'Billing Details:',
    contentTitle: 'Chegg Study Terms',
    content: {
      json: {
        data: {},
        content: [{
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'By clicking “Join now,” you will be enrolled in an auto-renewing monthly subscription for Chegg Study subject to these Chegg Study Terms and the Chegg Terms of Use.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: '\n',
            nodeType: 'text'
          }, {
            data: {},
            marks: [{
              type: 'underline'
            }],
            value: 'Auto-Renewal',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: '\nYour Chegg Study subscription will be renewed each month until you cancel. You consent to Chegg automatically charging your payment method on file ${price} each month (+ tax if applicable) until you cancel. ',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: '\n\n',
            nodeType: 'text'
          }, {
            data: {},
            marks: [{
              type: 'underline'
            }],
            value: 'How to Cancel',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: '\nYou can cancel your subscription anytime by visiting "My Account" on Chegg.com, clicking "Cancel," and completing the steps to cancel. Cancellations take effect at the end of the billing month in which your request to cancel was received. Following cancellation, you will continue to have access to your subscription until the end of your current billing period. To the extent permitted by law or otherwise set out in these terms, subscription fees are not refundable. ',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [{
              type: 'underline'
            }],
            value: 'Device Policy',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'You can access and use Chegg Study on up to (2) different devices that must be registered at My Account > My Devices.\n',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [{
              type: 'underline'
            }],
            value: 'Chegg Study Monthly Subscription Includes:',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            content: [{
              data: {},
              content: [{
                data: {},
                marks: [],
                value: 'Access to up to five (5) textbook solution titles per month, ',
                nodeType: 'text'
              }],
              nodeType: 'paragraph'
            }],
            nodeType: 'list-item'
          }, {
            data: {},
            content: [{
              data: {},
              content: [{
                data: {},
                marks: [],
                value: 'the ability to post up to twenty (20) questions per month, and ',
                nodeType: 'text'
              }],
              nodeType: 'paragraph'
            }],
            nodeType: 'list-item'
          }, {
            data: {},
            content: [{
              data: {},
              content: [{
                data: {},
                marks: [],
                value: 'unlimited viewing of the Q&A archive. ',
                nodeType: 'text'
              }],
              nodeType: 'paragraph'
            }],
            nodeType: 'list-item'
          }],
          nodeType: 'unordered-list'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Unused monthly subscription benefits have no cash value, are not transferrable, and expire at the end of each month. This means that subscription benefits do not roll over to or accumulate for use in subsequent months. ',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }],
        nodeType: 'document'
      }
    },
    link: 'Chegg Study Terms',
    backButtonText: 'Back to checkout',
    tncPromptText: 'By clicking Join Now you are agreeing to our ${cheggStudyPackTerms}, ${cheggTermsOfUse}, ${privacyPolicy} and for Chegg to charge your payment method for ${price} (+ tax if applicable) for your monthly subscription to Chegg Study. Chegg will automatically charge your payment method monthly until you elect to cancel by selecting cancel membership in My Account.',
    tncPromptTextWithCoupon: "By clicking Join Now you are agreeing to our ${cheggStudyPackTerms}, ${cheggTermsOfUse}, ${privacyPolicy} and for Chegg to charge your payment method for ${priceWithDiscount} today. After that, you'll be charged ${price} per month (+ tax if applicable) for your monthly subscription to Chegg Study. Chegg will automatically charge your payment method monthly until you elect to cancel by selecting cancel membership in My Account.",
    cheggTermsOfUseText: 'Chegg Terms of Use',
    cheggTermsOfUseLink: '/termsofuse',
    privacyPolicyText: 'Privacy Policy',
    privacyPolicyLink: '/privacypolicy'
  },
  orderSummary: {
    heading: 'Order summary:',
    subscription: 'Chegg Study subscription:',
    tax: 'Tax:',
    total: 'Order total:',
    totalPlusTax: '${price} + tax'
  },
  errorModal: {
    header: 'Something went wrong.',
    body: 'Our team is working on it.  Please try again later.'
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/constants/ContentfulFallback/CSResubscribe.js
// module id = 4185
// module chunks = 11